/* __next_internal_client_entry_do_not_use__ Span,Weight,Bold,Medium,Light,Book,Thin,Color,ColorSpan auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Color as Colors } from "../../slate/Color";
import { themeOrDefault } from "../../slate/Theme";
import { TypographyContext, TypographyStyles } from "./Typography";
export var Span = styled.span.withConfig({
    componentId: "sc-a58cfe41-0"
})([
    "",
    ";"
], function(param) {
    var $typography = param.$typography, $propsFilter = param.$propsFilter, theme = param.theme;
    return TypographyStyles($typography, themeOrDefault(theme), $propsFilter);
});
export var Weight = function(_param) {
    var weight = _param.weight, children = _param.children, props = _object_without_properties(_param, [
        "weight",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(TypographyContext.Consumer, {
        children: function(value) {
            return /*#__PURE__*/ _jsx(Span, _object_spread_props(_object_spread({}, props), {
                $typography: _object_spread_props(_object_spread({}, value || {}), {
                    weight: weight
                }),
                $propsFilter: [
                    "font-family",
                    "font-weight"
                ],
                children: children
            }));
        }
    });
};
/**
 * Span that changes the `font-weight` to Faire's `bold` variant.
 */ export var Bold = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Weight, _object_spread_props(_object_spread({}, props), {
        weight: "bold",
        children: children
    }));
};
/**
 * Span that changes the `font-weight` to Faire's `medium` variant.
 */ export var Medium = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Weight, _object_spread_props(_object_spread({}, props), {
        weight: "medium",
        children: children
    }));
};
/**
 * Span that changes the `font-weight` to Faire's `light` variant.
 */ export var Light = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Weight, _object_spread_props(_object_spread({}, props), {
        weight: "light",
        children: children
    }));
};
/**
 * Span that changes the `font-weight` to Faire's `book` variant.
 */ export var Book = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Weight, _object_spread_props(_object_spread({}, props), {
        weight: "book",
        children: children
    }));
};
/**
 * Span that changes the `font-weight` to Faire's `thin` variant.
 */ export var Thin = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Weight, _object_spread_props(_object_spread({}, props), {
        weight: "thin",
        children: children
    }));
};
export var Color = styled.span.withConfig({
    componentId: "sc-a58cfe41-1"
})([
    "color:",
    ";"
], function(param) {
    var color = param.color;
    return Colors[color] || color;
});
/**
 * Generator for a type that emits a span of the given color.
 * Useful when using the color span in many places.
 * @example ```
 * const DarkGold = ColorSpan(Color.darkGold);
 * <DarkGold>this text will be dark gold!</DarkGold>
 * ```
 */ export var ColorSpan = function(color) {
    return function ColorSpan(param) {
        var children = param.children;
        return /*#__PURE__*/ _jsx(Color, {
            color: color,
            children: children
        });
    };
};
